import { getExtensionContext, getService } from 'azure-devops-extension-sdk';
let dialogService = null;
let dialogServicePromise = null;
/**
 * Initializes the dialog service if it's not already initialized.
 * Uses a single promise to prevent duplicate initialization calls.
 * @returns A promise that resolves to the dialog service.
 */
const initializeDialogService = async () => {
    if (dialogService) {
        return dialogService;
    }
    // If initialization is in progress, return the existing promise
    if (dialogServicePromise) {
        return dialogServicePromise;
    }
    // Start initialization and cache the promise
    dialogServicePromise = getService('ms.vss-features.host-page-layout-service')
        .then((service) => {
        dialogService = service;
        return service;
    })
        .catch((error) => {
        dialogServicePromise = null; // Allow retry on failure
        throw error;
    });
    return dialogServicePromise;
};
// Pre-initialize dialog service to reduce first-click latency
// Note: Don't wait for ready() here as it may not resolve if loaded: false is used
// The service will be initialized when first needed
setTimeout(() => {
    initializeDialogService().catch(() => {
        // Ignore pre-initialization errors - will retry when panel is opened
    });
}, 100);
/**
 * Opens a custom dialog with the given configuration.
 * @param title The title of the panel.
 * @param description The description of the panel.
 * @param contributionId The contribution ID of the panel.
 * @param configuration The configuration for the panel.
 * @param onClose The callback function to execute when the panel is closed.
 * @param size The size of the panel.
 */
export const openPanel = async (title, description, contributionId, configuration, onClose) => {
    const service = await initializeDialogService();
    const extensionContext = getExtensionContext();
    const fullContributionId = `${extensionContext.id}.${contributionId}`;
    service.openPanel(fullContributionId, {
        title,
        description,
        size: 1,
        lightDismiss: false,
        configuration: {
            ...configuration,
        },
        onClose,
    });
};
